import {Dialog, DialogContent, DialogTitle, Grid, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BillingAddress = (props: any) => {

    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'contract.billingAddress'});
    const billingAddress = props.billingAddress;
    const open = props.open;

    return (

        <Dialog maxWidth={"xs"}  open={open}
                onClose={() => {
                    props.onClose();
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('billingAddress') + " " + props.bpCode}
                </Typography>
                <IconButton
                    aria-label="close" onClick={()=> props.onClose()}
                    sx={{ position: 'absolute', right: 8, top: 8, }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container columnSpacing={3} rowSpacing={1}>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="country"
                            value={billingAddress?.country}
                            label={t("country")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="province"
                            value={billingAddress?.province}
                            label={t("province")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="city"
                            value={billingAddress?.city}
                            label={t("city")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="zipCode"
                            value={billingAddress?.zipCode}
                            label={t("zipCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="street"
                            value={billingAddress?.street}
                            label={t("street")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="houseNumber"
                            value={billingAddress?.houseNumber}
                            label={t("houseNumber")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="addrEmail"
                            value={billingAddress?.addrEmail}
                            label={t("addrEmail")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="pec"
                            value={billingAddress?.pec}
                            label={t("pec")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="recipientCode"
                            value={billingAddress?.recipientCode}
                            label={t("recipientCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>

                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="telephone"
                            value={billingAddress?.telephone}
                            label={t("telephone")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="fax"
                            value={billingAddress?.fax}
                            label={t("fax")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            fullWidth
                            id="website"
                            value={billingAddress?.website}
                            label={t("website")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>

    );
};

export default BillingAddress;